import { useEffect, useRef } from "react";

export const useDocumentEvent = <T extends Event>(events: string, callback: (event: T) => void) => {
  const ref = useRef(callback);
  ref.current = callback;

  useEffect(() => {
    const eventsArray = events.split(' ');
    const handler = ((e: Event) => ref.current(e as T)) as EventListener;
    eventsArray.forEach(event => document.addEventListener(event, handler));
    return () => eventsArray.forEach(event => document.removeEventListener(event, handler));
  }, [events, ref]);
};

export const useElementEvent = <T extends Event>(element: HTMLElement | string | null, events: string, callback: (event: T) => void) => {
  const ref = useRef(callback);
  ref.current = callback;

  if (typeof element === 'string') {
    if (typeof window === 'undefined') element = null;
    else element = document.getElementById(element);
  }

  useEffect(() => {
    if (!element) return;
    const eventsArray = events.split(' ');
    const handler = ((e: Event) => ref.current(e as T)) as EventListener;
    eventsArray.forEach(event => element?.addEventListener(event, handler));
    return () => eventsArray.forEach(event => element?.removeEventListener(event, handler));
  }, [element, events, ref]);
}